import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertTriangle } from 'lucide-react';

const EnhancedLoginAlert = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (searchParams.get('denied') === '1') {
      setShowAlert(true);
      // Clean up URL parameter after showing alert
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('denied');
      setSearchParams(newParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  if (!showAlert) {
    return null;
  }

  return (
    <Alert variant="destructive" className="mb-6">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Truy cập bị từ chối</AlertTitle>
      <AlertDescription className="mt-2">
        Tài khoản của bạn chưa được cấp quyền truy cập hệ thống. 
        Vui lòng liên hệ với quản trị viên để được hỗ trợ.
      </AlertDescription>
    </Alert>
  );
};

export default EnhancedLoginAlert;